import { Fragment } from "react";
import { I } from "@/components/kamibot-v2/discord";

type CellValue = boolean | string;

type CompareRow = {
  label: string;
  free: CellValue;
  pro: CellValue;
  studio: CellValue;
};

type CompareGroup = {
  group: string;
  rows: CompareRow[];
};

const COMPARE_ROWS: CompareGroup[] = [
  {
    group: "기본",
    rows: [
      { label: "TTS · 음성 합성", free: "30초까지 · 표준", pro: "5분까지 · 고급", studio: "5분까지 · 고급" },
      { label: "AI 어시스턴트", free: "일 50회", pro: "무제한", studio: "무제한" },
      { label: "자동 번역", free: "108개 언어", pro: "108개 언어", studio: "108개 언어" },
      { label: "환영 카드 · 임시 음성", free: true, pro: true, studio: true },
      { label: "음악 재생", free: "표준 음질", pro: "고품질 · 우선 큐", studio: "고품질 · 우선 큐" },
    ],
  },
  {
    group: "고급",
    rows: [
      { label: "AI 자동화 (모더레이션 · 요약)", free: false, pro: true, studio: true },
      { label: "서버 분석 대시보드", free: false, pro: false, studio: true },
      { label: "API 우선순위", free: "공용 큐", pro: "프리미엄 큐", studio: "전용 큐" },
    ],
  },
  {
    group: "감사 표시",
    rows: [
      { label: "서포터 ✦ 마크 (디스코드 역할)", free: false, pro: true, studio: true },
      { label: "서포터 전용 공지 채널", free: false, pro: true, studio: true },
      { label: "카미봇이 보내는 감사 메시지", free: false, pro: "월 1회", studio: "월 1회 + 손편지" },
      { label: "비하인드 스토리 · 개발 노트", free: false, pro: true, studio: true },
    ],
  },
  {
    group: "스튜디오 전용",
    rows: [
      { label: "커스텀 봇 (이름 · 프로필 사진 · 소개)", free: false, pro: false, studio: true },
      { label: "임베드 색 · 응답 톤 커스텀", free: false, pro: false, studio: true },
      { label: "내 봇 토큰으로 직접 만들기", free: false, pro: false, studio: true },
      { label: "우선 지원 (24시간 내 응답)", free: false, pro: false, studio: true },
    ],
  },
  {
    group: "마음",
    rows: [
      { label: "환불 · 14일 보장", free: "—", pro: true, studio: true },
      { label: "언제든 해지 가능", free: "—", pro: true, studio: true },
      { label: "무료 기능은 유료가 되어도 무료", free: true, pro: true, studio: true },
    ],
  },
];

function Cell({ v }: { v: CellValue }) {
  if (v === true)
    return (
      <span className="cmp-yes" aria-label="포함">
        <I.check />
      </span>
    );
  if (v === false)
    return (
      <span className="cmp-no" aria-label="미포함">
        —
      </span>
    );
  return <span className="cmp-text">{v}</span>;
}

export function PremiumCompare() {
  return (
    <section className="prem-compare" id="compare">
      <div className="shell">
        <div className="section-head">
          <span className="section-eyebrow">
            <I.list /> COMPARE · 비교
          </span>
          <h2 className="section-title">한 번에 보고 결정해요.</h2>
          <p className="section-sub">
            잠겨 있는 칸이 무료 분들께 미안한 게 아니라, 무료 분들의 자리가 더 안정적이라는 뜻이에요.
          </p>
        </div>

        <div className="prem-compare-wrap">
          <table className="prem-compare-table">
            <thead>
              <tr>
                <th className="cmp-th-feature">기능</th>
                <th className="cmp-th-plan">
                  <span className="cmp-plan-name">무료</span>
                  <span className="cmp-plan-price">₩0</span>
                </th>
                <th className="cmp-th-plan is-hi">
                  <span className="cmp-plan-name">프로</span>
                  <span className="cmp-plan-price">
                    ₩4,900<small>/월</small>
                  </span>
                </th>
                <th className="cmp-th-plan">
                  <span className="cmp-plan-name">스튜디오</span>
                  <span className="cmp-plan-price">
                    ₩19,900<small>/월</small>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {COMPARE_ROWS.map((g, gi) => (
                <Fragment key={gi}>
                  <tr className="cmp-group-row">
                    <th colSpan={4}>{g.group}</th>
                  </tr>
                  {g.rows.map((r, ri) => (
                    <tr key={ri}>
                      <td className="cmp-feature">{r.label}</td>
                      <td>
                        <Cell v={r.free} />
                      </td>
                      <td className="is-hi">
                        <Cell v={r.pro} />
                      </td>
                      <td>
                        <Cell v={r.studio} />
                      </td>
                    </tr>
                  ))}
                </Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
